import styled from 'styled-components';
import { NamedContentEntryText } from '../../ContentEntryText/NamedContentEntryText';

export const User: React.FC<{ name: string | null; role: 'learner' | 'manager' | null }> = ({ name, role }) => {
  return (
    <UserContainer>
      <UserName>{name ?? ''}</UserName>

      <p className="role">
        {role && (
          <NamedContentEntryText
            container="span"
            refKey="menuSystem"
            subKey={role === 'learner' ? 'user' : 'manager'}
          />
        )}
      </p>
    </UserContainer>
  );
};
const UserName = styled.p`
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.heading};
`;
const UserContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .role {
    font-size: 11px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.mutedForeground};
    text-transform: capitalize;
  }
`;
